import ButtonLight from '../UI/ButtonLight';
import H3Header from '../UI/H3Header';
import H4Header from '../UI/H4Header';
// import TechStackProject from '../UI/TechStack';

const ProjectRight = props => {
    return (
        <div class="mt-32 flex flex-wrap-reverse gap-6 max-w-5xl mx-auto px-2 text-white">
            <div data-theme="mytheme" class="max-w-sm justify-self-end mx-auto">
                <div class="w-6/12 mx-auto lg:mx-0 lg:ml-auto lg:w-8/12 pt-14">
                    <ButtonLight goTo={props.buttonDescription} target='_blank' rel="noreferrer">Details</ButtonLight>
                    <ButtonLight goTo={props.buttonGitHub} target='_blank' rel="noreferrer">GitHub</ButtonLight>
                    <div class={`${props.bgImage} bg-contain bg-no-repeat opacity-20 w-56 h-56 z-0 hidden lg:block`}></div>
                </div>
            </div>
            <div class="w-full md:w-9/12 md:mx-auto lg:max-w-xl">
                <H3Header>
                    {props.projectTitle}
                </H3Header>
                <H4Header>
                    {props.myRole}
                </H4Header>
                {props.children}
				{/* <TechStackProject meep={props.techStack}/> */}
            </div>
        </div >
    );
};

export default ProjectRight;
